'use es6';

import { createBrowserHistory, createLocation } from 'history';
import { debug } from './env';

const _debug = () => debug('history');

let history;
export const getHistory = () => {
  return history;
};
export const setHistory = _history => {
  history = _history;
};
export const createHistory = basename => {
  history = createBrowserHistory({
    basename
  });
  return history;
};
export const push = (...args) => {
  if (!history) {
    throw new Error('history not initialized');
  }

  if (_debug()) {
    console.groupCollapsed('history: push');
    console.log('args:', ...args);
    console.groupEnd();
  }

  return history.push(...args);
};
export const replace = (...args) => {
  if (!history) {
    throw new Error('history not initialized');
  }

  if (_debug()) {
    console.groupCollapsed('history: replace');
    console.log('args:', ...args);
    console.groupEnd();
  }

  return history.replace(...args);
};
export const getFullHref = (to, includeProtocol = true) => {
  if (!history) {
    throw new Error('history not initialized');
  }

  const {
    protocol,
    hostname
  } = window.location;
  const location = typeof to === 'string' ? createLocation(to, null, null, history.location) : to;
  const href = history.createHref(location);
  return `${includeProtocol ? `${protocol}//` : ''}${hostname}${href}`;
};